export default __webpack_public_path__ + "images/dcn_cff5c4.svg";